import type { IUserGtmInfoPayload } from '@/interfaces'
import type { IBaseGtmEventFinancing } from '@/logic/metrika/financing/types'
import { pushGtmEvent } from '@/logic/metrika/helpers'

export const pushGtmEventOnClickFinancingActionOffer = (
  userGtmInfo: IUserGtmInfoPayload,
  userRegionName: string,
  eventContext: Maybe<string>,
) => {
  pushGtmEvent<IBaseGtmEventFinancing>({
    event: 'userEvent',
    regionSelected: userRegionName,
    eventCategory: 'interactions',
    eventAction: 'click',
    blockName: 'blockFinanceAvans',
    eventLabel: 'conversion_button_click',
    eventContext,
    ...userGtmInfo,
  })
}

export const pushGtmEventOnChangeCalculate = (userGtmInfo: IUserGtmInfoPayload, userRegionName: string, eventContext: Maybe<string>) => {
  pushGtmEvent<IBaseGtmEventFinancing>({
    event: 'userEvent',
    regionSelected: userRegionName,
    eventCategory: 'interactions',
    eventAction: 'click',
    blockName: 'blockFinanceAvans',
    eventLabel: 'calculator_click',
    eventContext,
    ...userGtmInfo,
  })
}

export const pushGtmEventOnExpand = (userGtmInfo: IUserGtmInfoPayload, userRegionName: string, eventContext: Maybe<string>) => {
  pushGtmEvent<IBaseGtmEventFinancing>({
    event: 'userEvent',
    regionSelected: userRegionName,
    eventCategory: 'interactions',
    eventAction: 'click',
    blockName: 'blockFinanceAvans',
    eventLabel: 'advance_conditions',
    eventContext,
    ...userGtmInfo,
  })
}
